<template>
    <div class="card card-default">
        <div class="card-header">
            <h5 class="card-title mb-0">Available Rewards ({{ loyaltyScheme.name }})</h5>
        </div>
        <div class="card-body">
            <div class="form-group select">
                <label for="redeemed-reward" class="control-label">Redeemed Reward</label>
                <select
                    class="form-control"
                    id="redeemed-reward"
                    name="redeemed_reward"
                    v-model="loyaltySchemePointsTierId"
                >
                    <option disabled selected value="">-- PLEASE SELECT --</option>
                    <option
                        :disabled="loyaltySchemePointsTier.points > userLoyaltyPoints"
                        :key="loyaltySchemePointsTier.id"
                        :value="loyaltySchemePointsTier.id"
                        v-for="loyaltySchemePointsTier in loyaltyScheme.loyalty_scheme_points_tiers"
                        v-text="`${loyaltySchemePointsTier.reward_name} - (${loyaltySchemePointsTier.points})`"
                    ></option>
                </select>
            </div>
            <p class="card-text" v-if="tierSelected">{{ description }}</p>
            <button
                class="btn btn-success btn-block"
                @click="redeem"
                :disabled="!tierSelected"
            >
                Redeem
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RedeemedLoyaltySchemePointsAddForm',

    props: {
        loyaltyScheme: {
            required: true,
            type: Object,
        },
        userLoyaltyPoints: {
            default: 0,
            required: false,
            type: Number,
        },
    },

    data() {
        return {
            loyaltySchemePointsTierId: '',
        }
    },

    computed: {
        description() {
            if (this.loyaltySchemePointsTier === null) {
                return '';
            }

            let text = `You have selected to redeem ${this.loyaltySchemePointsTier.points} loyalty points for a ${this.loyaltySchemePointsTier.reward_name}.`;

            if (this.loyaltySchemePointsTier.gift_card === null) {
                return text;
            }

            return `${text} This Gift Card is worth ${this.loyaltySchemePointsTier.gift_card.price_display} and is valid for ${this.loyaltySchemePointsTier.gift_card.expiry_period} months.`;
        },
        loyaltySchemePointsTier() {
            return this.tierSelected
                ? this.loyaltyScheme.loyalty_scheme_points_tiers.find(tier => tier.id === Number(this.loyaltySchemePointsTierId))
                : null;
        },
        tierSelected() {
            return this.loyaltySchemePointsTierId !== '';
        },
    },

    methods: {
        redeem() {
            if (!confirm(`${this.description} Are you sure that you are happy with this choice?`)) {
                return;
            }

            axios
                .post('/api/internal/RedeemedLoyaltySchemePoints/add.json', {
                    loyalty_scheme_points_tier_id: this.loyaltySchemePointsTierId,
                })
                .then(res => res.data.errors.message ? alert('You dont have sufficient points to redeem this reward') : window.location.reload());
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/RedeemedLoyaltySchemePoints/Form/Add.vue